import { useMutation, useSharedStore, useAuthStore, cookie, notify } from '@/presentation';
import router from '@/presentation/router';
import type { AxiosError } from 'axios';

interface RefreshTokenResponse {
	accessToken: string;
	refreshToken: string;
	[key: string]: any;
}

interface RefreshTokenError {
	Message?: string;
	[key: string]: any;
}

export const handleRefreshToken = async (error: AxiosError): Promise<void> => {
	const refreshToken = cookie.get('refresh-token');
	const accessToken = cookie.get('access-token');

	const sharedStore = useSharedStore();
	const authStore = useAuthStore();

	if (refreshToken) {
		const { mutate: getRefreshToken } = useMutation<string, RefreshTokenResponse, unknown>({
			mutationFn: authStore.loginByRefreshToken,
			onSuccess: (response: RefreshTokenResponse) => {
				cookie.set('refresh-token', response.refreshToken);
				cookie.set('access-token', response.accessToken);
				location.reload();
			},
		});

		getRefreshToken(refreshToken);

		if (error.config?.url?.includes('LoginByRefreshToken')) {
			sharedStore.logout();
			router.replace('/auth/login');

			const data = error.response?.data as RefreshTokenError;
			const message = data?.Message ?? 'درخواست مورد نظر یافت نشد';

			notify({ message, type: 'error' });
		}
	}

	if (!refreshToken && !accessToken) {
		router.replace('/auth/login');
	}
};
